import axios from 'axios';
axios.defaults.headers =  {
  "Content-Type" : "application/json",
  'x-auth-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7IklEIjoiMSJ9LCJpYXQiOjE1ODU5Njc3NzJ9.PxeNTlfLGTrEUQm9DDbtFMCnUf8VffXTKg1FWZVhtVA'
}
export default axios.create({baseURL: "https://rgrs.pelkonet.com/"});
//export default axios.create({baseURL: "http://192.168.25.134:5000/"});